import React from 'react';

function FeatureItem({
  iconSrc,
  heading,
  className = 'items-center',
  content,
  headingClass,
  contentClass,
  iconClass = '',
  imgHeight,
}) {
  return (
    <div className={`flex flex-col ${className}`}>
      {iconSrc && (
        <div className={`flex mb-5 ${iconClass}`}>
          <img src={iconSrc} alt={''} className={`object-contain ${imgHeight || 'h-24'}  `} />
        </div>
      )}
      {heading && <h4 className={`mb-3 text-h4 ${headingClass}`} dangerouslySetInnerHTML={{ __html: heading }} />}
      {content && (
        <div className="">
          <div className={`prose ${contentClass || 'text-center'}`} dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      )}
    </div>
  );
}

export default FeatureItem;
